import styled from 'styled-components'
import { COLOR, FONT_SIZE } from '../../themes'

export const TOAST_STYLE_COPY = styled.div`
  height: 48px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  padding: 0 15px;
  font-size: ${FONT_SIZE.TN};
  font-weight: 700;
  position: fixed;
  z-index: 999999;
  bottom: 27px;
  left: 42%;
  transition: transform 0.5s ease-in-out;
  animation: toast-in-right 0.5s;

  .divider {
    margin: 0 25px 0 0;
    height: 32px;
    width: 1px;
    background: ${COLOR.WHITE};
  }

  .message {
    white-space: pre-wrap;
    width: 280px;
    color: ${COLOR.WHITE};
    text-align: start;
  }

  .close-btn {
    cursor: pointer;
  }

  @keyframes toast-in-right {
	from {
	  transform: translateX(100%);
	  
	}
	to {
	  transform: translateX(0);
	}
}
`
